<template lang="pug">
  div#header
    v-container.pa-0(text-xs-center fluid)
      img.header-logo.mt-5.mb-3.pb-4(src="../assets/logo.png")
      v-layout(row wrap justify-center)
        v-flex(xs12)
          v-card.h-card.py-4.mb-5(flat)
            h1.py-2.text-sm-center.mb-0 Asesorías realizadas por
              br
              span.bold.smaller el Centro Diocesano para los Derechos Humanos
              br
              span.bolder.small Fray Juan de Larios
</template>

<script>
export default {
  name: "Header",
  props: {}
};
</script>

<style lang="scss">
#header {
  background-color: #fff;
  .header-logo {
    max-width: 33vw;
  }
}
#header .h-card {
  background-image: linear-gradient(to bottom, #1b5404, #2f701d);
}

h1 {
  color: #fff;
  line-height: 0.85;
  font-size: 3.3rem;
  font-weight: 400;
}
</style>
